<template lang="pug">
iframe(
  id="instruction_player"
  :style="`min-height:${minHeight}px`"
  width="100%"
  height="100%"
  :src="`${getYoutubeEmbedLink(src)}?enablejsapi=1&html5=1&rel=0&autoplay=${stop ? 0 : 1}&showinfo=0', frameborder='0'`"
  allowfullscreen
  frameBorder="0"
  v-bind="$attrs"
)
</template>

<script>
import { getYoutubeEmbedLink } from '@/helpers/youtube-embed';

export default {
  props: {
    src: { type: String, required: true },
    stop: { type: Boolean, required: false, default: false },
    minHeight: { type: Number, default: 200 },
  },
  watch: {
    stop:{
      immediate:true,
      handler(val) {
        const iframe = document.querySelector('#instruction_player')?.contentWindow;
        if (iframe) {
          const func = val ? 'pauseVideo' : 'playVideo';
          iframe.postMessage(`{"event":"command","func":"${func}","args":""}`, '*');
        }
      },
    },
  },
  methods: {
    getYoutubeEmbedLink(link) {
      return getYoutubeEmbedLink(link);
    },
  },
};
</script>

<style>

</style>
